import styled from "styled-components";
import { transition } from "@evergis/ui";

export const ChatWidthDrag = styled.div<{ disabled?: boolean }>`
  position: absolute;
  left: 0;
  top: calc(50% - 1rem);
  display: flex;
  justify-content: center;
  cursor: grab;
  align-self: center;
  padding: 0.25rem 0.5rem;
  pointer-events: ${({ disabled }) => disabled && "none"};

  &:after {
    content: "";
    display: block;
    width: 0.25rem;
    height: 2rem;
    background-color: ${({ disabled, theme: { palette } }) => !disabled && palette.elementDeep};
    border-radius: 0.125rem;
    transition: background-color ${transition.hover};
  }

  &:hover:after {
    background-color: ${({ theme: { palette } }) => palette.iconDisabled};
  }
`;
